// extracted by mini-css-extract-plugin
module.exports = {"w1ssr0nu":"w1ssr0nu","sl5orpt":"sl5orpt","ffvvd8v":"ffvvd8v","t1vpk1yl":"t1vpk1yl"};